const config = {
  colorScheme: '1',
  desktopMediaPosition: 'left',
  desktopMediaLayout: 'carouselThumbnails',
  mediaSize: 'small',
  switchToVariantImage: 'true',
  enableImageNotAvailablePreview: 'true',
  mediaFit: 'original',
  blocks: [
    {
      key: 'INVENTORY_STATUS',
      fkEcomStoreThemeSectionBlockType: 27,
      hidden: false,
      config: {
        textStyle: 'normal',
        visibleWhenNotTracked: 'FALSE',
        useInventoryThreshold: 'true',
        inventoryThreshold: '25',
        showInventoryCount: 'true'
      }
    },
    {
      key: 'TITLE',
      fkEcomStoreThemeSectionBlockType: 5,
      hidden: false,
      config: {
        titleSize: '28',
        titleMobileSize: '20',
        fontSize: '20'
      }
    },
    {
      key: 'PRICE',
      fkEcomStoreThemeSectionBlockType: 10,
      hidden: false,
      config: {}
    },
    {
      key: 'VARIANT_PICKER',
      fkEcomStoreThemeSectionBlockType: 11,
      hidden: false,
      config: { variantStyle: 'dropdown' }
    },
    {
      key: 'QUANTITY_SELECTOR',
      fkEcomStoreThemeSectionBlockType: 12,
      isVisible: ({ isCartEdit, isPreview }) => !isCartEdit
    },
    {
      key: 'BUY_BUTTONS',
      fkEcomStoreThemeSectionBlockType: 13,
      isVisible: ({ isCartEdit, isPreview }) => !isCartEdit,
      hidden: false,
      config: {}
    },
    {
      key: 'DESCRIPTION',
      fkEcomStoreThemeSectionBlockType: 26,
      isVisible: ({ isCartEdit, isPreview }) => !isCartEdit && !isPreview,
      hidden: false,
      config: {}
    }
  ]
};

export { config };
